import WhatsIncluded from './whats-included'
export default WhatsIncluded